<background-modal>
  <h1 i18n>404</h1>
  <span i18n>It seams like, you have a wrong registration link.</span>
</background-modal>
